import { TitleCasePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import {
  CIS_CHIP_BEHAVIORS,
  CIS_CHIP_TYPES,
  IChipSearchFilterElement,
} from '@el-chip-input-search';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';

import {
  ATTENDANCE_LOCATION,
  ATTENDANCE_SOURCE,
  ATTENDANCE_STATUS,
  MODULES,
} from '@shared/constants';
import { IModule } from '@shared/interfaces';

import { ModulesService } from '../../modules/services/modules.service';
import { ReferenceService } from '../../references/services';

@Injectable({ providedIn: 'root' })
export class AttendanceComponentCISService {
  moduleConfig: IModule;

  constructor(
    modulesService: ModulesService,
    private referenceService: ReferenceService,
    private translateService: TranslateService,
    private titleCasePipe: TitleCasePipe
  ) {
    modulesService.getModuleByKey(MODULES.SUPPORT_TICKETS).then((res) => {
      this.moduleConfig = res;
    });
  }

  private getSearchDropDowns() {
    const statusDropdown = Object.entries(ATTENDANCE_STATUS).map(
      ([, value]) => ({
        key: this.titleCasePipe.transform(
          (value || '').toString().replace('_', '  ')
        ),
        value,
      })
    );

    const sourceDropDown = Object.entries(ATTENDANCE_SOURCE).map(
      ([, value]) => ({
        key: this.titleCasePipe.transform(
          (value || '').toString().replace('_', '  ')
        ),
        value,
      })
    );

    const locationDropDown = Object.entries(ATTENDANCE_LOCATION).map(
      ([, value]) => ({
        key: this.titleCasePipe.transform(
          (value || '').toString().replace('_', '  ')
        ),
        value,
      })
    );

    return {
      sourceDropDown,
      statusDropdown,
      locationDropDown,
    };
  }

  getAllCISChipsList() {
    const { sourceDropDown, statusDropdown, locationDropDown } =
      this.getSearchDropDowns();
    const chipsData: IChipSearchFilterElement[] = [
      {
        name: this.translateService.instant('Status'),
        chipProperties: {
          type: CIS_CHIP_TYPES.SELECT,
          key: 'status',
          properties: {
            options: statusDropdown,
          },
        },
        behavior: CIS_CHIP_BEHAVIORS.DEFAULT,
      },
      {
        name: this.translateService.instant('Source'),
        chipProperties: {
          type: CIS_CHIP_TYPES.SELECT,
          key: 'source',
          properties: {
            options: sourceDropDown,
          },
        },
        behavior: CIS_CHIP_BEHAVIORS.DEFAULT,
      },

      {
        name: this.translateService.instant('Location'),
        chipProperties: {
          type: CIS_CHIP_TYPES.SELECT,
          key: 'place',

          properties: {
            options: locationDropDown,
          },
        },
        size: 250,
      },

      {
        name: this.translateService.instant('vacancies.cis.created-date-range'),
        chipProperties: {
          type: CIS_CHIP_TYPES.DATE_RANGE,
          minKey: 'created_date_from',
          maxKey: 'created_date_to',
          minPlaceholder: this.translateService.instant('logs.from'),
          maxPlaceholder: this.translateService.instant('logs.to'),
          minValue: moment().subtract(7, 'days').toDate(),
          maxValue: moment().toDate(),
        },
      },
    ];
    return { chipsData };
  }
}
